/** Reserva síncrona independente do estado visual, compartilhada por sync e auto-push. */
let active: symbol | null = null;

export const hasSyncExecution = (): boolean => active !== null;
export const reserveSyncExecution = (): (() => void) | null => {
  if (active) return null;
  const owner = Symbol('sync');
  active = owner;
  return () => { if (active === owner) active = null; };
};
